import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';

export const getAllCustomerThunk = createAsyncThunk(
  'customer/getAllCustomer',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllCustomer(config);
      return response.data?.data;
    } catch (error) {
      console.log(error);

    }
  }
);


export const getCustomerDetailsThunk = createAsyncThunk(
  'customer/getCustomerdetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getCustomerDetails(id);

      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);



export const customerrejectOrAproveThunk = createAsyncThunk(
  'customerreject/customerrejectoraprove',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.rejectOrAproveCustomer(data);
      toast.success(response.data?.data?.message || 'success')
      dispatch(setCustomerRefresh())
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const deletecustomerThunk = createAsyncThunk(
  'deletecustomer/deletecustomerThunk',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.deleteCustomer(data);
      toast.success(response.data?.data?.message || 'success')
      dispatch(setCustomerRefresh())
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')
    }
  }
);



export const addCustomerThunk = createAsyncThunk(
  'customer/addcustomer',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.addCustomer(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);



export const editCustomerThunk = createAsyncThunk(
  'customer/editCustomerThunk',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.updateCustomer(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const exportCustomerThunk = createAsyncThunk(
  'customer/exportCustomer',
  async (config, { rejectWithValue,dispatch }) => {
    try {
      const response = await api.exportCustomer(config);
      
      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);



export const getAllTypeCustomers = createAsyncThunk(
  'customer/getAllTypeCustomers',
  async (config, { rejectWithValue,dispatch }) => {
    try {
      const response = await api.getAllTypeCustomer(config);
      
      dispatch(setExportCustomerData(response.data?.data))
      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);


export const editRemarksThunk = createAsyncThunk(
  'customer/editRemarksThunk',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.updateRemarks(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const getAllUsersThunk = createAsyncThunk(
  'customer/getAllUsersThunk',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.getAllUsers(data);
      dispatch(setAllUsers(response?.data?.data))
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


// Slice for categories
const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    customer: [],
    customerDetails: {},
    editcustomer: null,
    loading: false,
    error: null,
    refresh: false,
    statusLoading: false,
    exportLoading:false,
    exportCustomerData:[],
    page:1,
    allUsers:[]
  },
  reducers: {
    setCustomerRefresh: (state, action) => {
      state.refresh = !state.refresh
    },
    setCustomerEdit: (state, action) => {
      state.editcustomer = action.payload;
    },
    setExportCustomerData:(state,action)=>{
          state.exportCustomerData = action.payload
    },
    setCustomerPage:(state,action)=>{
      state.page = action.payload
    },
    setAllUsers:(state,action)=>{
      state.allUsers = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomerThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCustomerThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.customer = action.payload;
      })
      .addCase(getAllCustomerThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //getdetails
      .addCase(getCustomerDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDetails = action.payload;
      })
      .addCase(getCustomerDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      //rejectoraprove
      .addCase(customerrejectOrAproveThunk.pending, (state) => {
        state.statusLoading = true;
        state.error = null;
      })
      .addCase(customerrejectOrAproveThunk.fulfilled, (state, action) => {
        state.statusLoading = false;

      })
      .addCase(customerrejectOrAproveThunk.rejected, (state, action) => {
        state.statusLoading = false;
        state.error = action.payload;
      })


      //export customer
      .addCase(exportCustomerThunk.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportCustomerThunk.fulfilled, (state, action) => {
        state.exportLoading = false;
      })
      .addCase(exportCustomerThunk.rejected, (state, action) => {
        state.exportLoading = false;
      })

  },
});

export const { setCustomerRefresh, setCustomerEdit,setExportCustomerData,setCustomerPage,setAllUsers } = customerSlice.actions

export default customerSlice.reducer;

